<script>
import { mapGetters } from 'vuex'
import PciDssPaymentForm from '@/views/ads/ads-top-up-response/components/pci-dss-payment-form.vue'
import CheckoutDotComPaymentForm from '@/views/ads/ads-top-up-response/components/checkout-dot-com-payment-form.vue'

export default {
  name: 'AdsPaymentMethod',
  components: {
    PciDssPaymentForm,
    CheckoutDotComPaymentForm,
  },
  computed: {
    ...mapGetters('ads', ['isAdsPciPaymentEnabled']),
  },
}
</script>

<template>
  <div class="w-full">
    <PciDssPaymentForm v-if="isAdsPciPaymentEnabled" />
    <CheckoutDotComPaymentForm v-else />
  </div>
</template>
